module.exports = __webpack_public_path__ + "img/6.2fb47794.jpg";